// Single source of truth for where an applicant must go while onboarding is
// incomplete. The real enforcement is server-side (StoreApplicationRequest only
// authorizes an apply when the profile is `active` and has personality data);
// this just drives navigation/UX so the steps can't be skipped in the client.

// An empty personality array means the assessment was never completed — match
// the backend, which treats an empty array as "no personality".
export function hasCompletedPersonality(profile) {
	const personality = profile?.personality
	return Array.isArray(personality) ? personality.length > 0 : !!personality
}

// Returns the path an existing-profile applicant must be sent to while
// onboarding is unfinished, or null when they are ready to apply.
export function onboardingRedirectPath(profile) {
	if (!hasCompletedPersonality(profile)) {
		return `/assessment/applicant/${profile.id}/consent`
	}

	if (!profile.active) {
		return `/applicant-profile/${profile.id}/setup`
	}

	return null
}
